export default __webpack_public_path__ + "static/assets/732af5f39332f8ad5017c6dc923e99e5.png";